require('fslightbox');

export default class FsLightboxInitilaizer {
    constructor(selectors) {
        this.items = document.querySelectorAll(selectors);
        if (this.items.length) {
            this.items.forEach((item) => {
                let gallery = item.getAttribute('rel') ?? '';
                item.setAttribute('data-fslightbox', gallery);
            });
            refreshFsLightbox();
        }
    }
}